import { IContextualMenuStyles, mergeStyleSets } from "@fluentui/react";
import { CSSProperties } from "react";
import { CustomCardProps } from "../Interfaces/CustomCard.interfaces";

export const horizontalBarHeaderShimmerStyles = {
  root: { width: "50%" },
  shimmerWrapper: {
    backgroundColor: "var(--shimmer-color)",
    borderTopLeftRadius: 6,
    height: 20
  },
  shimmerGradient: {
    backgroundColor: "var(--shimmer-color)"
  }
};
export const classNames = mergeStyleSets({
  layoutText: {
    color: "rgb(27, 26, 25)",
    fontSize: 14,
    textSizeAdjust: "100%",
    unicodeBidi: "isolate",
    WebkitFontSmoothing: "antialiased"
  } as CSSProperties,
  nameText: {
    fontWeight: 600,
    textOverflow: "ellipsis",
    textSizeAdjust: "100%",
    gridColumn: "1"
  } as CSSProperties,
  secondaryText: { color: "rgb(96, 94, 92)", gridColumn: "3", paddingLeft: ".5em" } as CSSProperties,
  essentialsSeparator: { padding: "0 3px" } as CSSProperties,
  headerLabel: { margin: 0, color: "rgb(0, 120, 212)" } as CSSProperties,
  appliedFiltersContainer: {
    alignItems: "baseline",
    borderRadius: 3,
    display: "grid",
    gap: "10px 5px",
    outline: "1px solid #eee",
    padding: 10
  } as CSSProperties,
  chartContainer: { minHeight: 240, transition: "min-height 1s ease-in-out"  } as CSSProperties
});

export const customCardStyles: CustomCardProps["styles"] = {
  root: { flex: 1, minHeight:"20%", height: "inherit", minWidth: "24%" },
  cardHeaderStart: { flex: 1 },
  cardHeaderTitleContainer: { flex: 1 },
  cardDetails: { height: "100%" }
};

export const customCardChartStyles: CustomCardProps["styles"] = {
  root: { flex: 1, minHeight:"20%", height: "inherit", minWidth: "25%" },
  cardDetails: { height: "100%" },
  cardHeaderStart: { flex: 1 },
  cardHeaderTitleContainer: { flex: 1 }
};

export const contextualMenuStyles: Partial<IContextualMenuStyles> = {
  root: { padding: "0 1em 1em" },
  header: { padding: 0 }
};

export const iconButtonStyles={
  root: { fontSize: "18px", padding: "10px", background: "#f3f3f3", borderRadius: "50%" },
  rootHovered: { background: "#e1e1e1" }
};
